import { useState } from "react";
import { ComboBox } from "../../components/ComboBox";
import { DateRangePicker } from "../../components/DateRangePicker";
import { Modal } from "../../components/Modal";
import { PeriodSelector } from "../../components/PeriodSelector";
import { StyledPeriodFilterModal } from "./style";

import useDateRangeStore from "../../store/useDateRangeStore";
import useModalStore from "../../store/useModalStore";

const OPTIONS_YEAR = [
  { label: "2024년", value: 2024 },
  { label: "2023년", value: 2023 },
  { label: "2022년", value: 2022 },
];

export const PeriodFilterModal = () => {
  const { mainStartDate, mainEndDate, setMainStartDate, setMainEndDate } =
    useDateRangeStore();
  const { setIsPeriodFilterModal } = useModalStore();

  const [year, setYear] = useState();
  const [tempStartDate, setTempStartDate] = useState(mainStartDate);
  const [tempEndDate, setTempEndDate] = useState(mainEndDate);

  const handleYearOnChange = (value) => {
    setYear(value);
    const newStartDate = new Date(value, 0, 1);
    const newEndDate = new Date(value, 11, 31);

    setTempStartDate(newStartDate);
    setTempEndDate(newEndDate);
  };

  const handleOnClick = () => {
    setMainStartDate(tempStartDate);
    setMainEndDate(tempEndDate);

    setIsPeriodFilterModal(false);
  };

  return (
    <Modal
      title="조회조건변경"
      caption="조회"
      modalToggle={setIsPeriodFilterModal}
      onClick={handleOnClick}
    >
      <StyledPeriodFilterModal>
        <div className="period-filter-container">
          <div>
            <DateRangePicker
              startDate={tempStartDate}
              endDate={tempEndDate}
              setStartDate={setTempStartDate}
              setEndDate={setTempEndDate}
            />
          </div>
          <div>
            <ComboBox
              placeholder="연도설정"
              options={OPTIONS_YEAR}
              value={year}
              onChange={handleYearOnChange}
            />
            <PeriodSelector
              monthMode={true}
              setStartDate={setTempStartDate}
              setEndDate={setTempEndDate}
            />
          </div>
        </div>
      </StyledPeriodFilterModal>
    </Modal>
  );
};
